import React from "react";
import RouteConfig from "./Utils/RouteConfig";

const App = () => {
  return (
    <div className="App">
      <RouteConfig />
    </div>
  );
};

export default App;
